export default __webpack_public_path__ + "static/media/pause-button.55bc3cff.png";